import React from 'react';

import meditationTrack from 'src/public/audio/3-minute-meditation.wav';
import deepBreathingTrack from 'src/public/audio/Deep_Breathing_1.8.mp3';
import meditateIcon from 'src/public/img/edit-goal-icon.png';
import deepBreathingIcon from 'src/public/img/illustration-deep-breathing.svg';

import * as S from '../../stepComponents/styles';
import { RelaxationInstructions } from '../components/RelaxationInstructions';
import { RelaxationStrategiesBox } from '../components/RelaxationStrategiesBox';

export const RelaxationsStrategiesStep: React.SFC = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>Relaxation Strategies</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow type="flex">
            <RelaxationStrategiesBox
                title="Meditate"
                icon={meditateIcon}
                track={meditationTrack}
                showMeditationsLink
            />
            <RelaxationStrategiesBox
                title="Deep Breathing"
                icon={deepBreathingIcon}
                track={deepBreathingTrack}
                instructions={<RelaxationInstructions />}
            />
        </S.ContentRow>
    </>
);
